import { BookmarkRemove, CalendarMonth,  Delete,  LinkRounded,  People,  PersonAdd,  PlaylistAddCheck,  School, SmartToy, Star, Telegram, WidgetsRounded } from '@mui/icons-material'
import React, { Fragment } from 'react'
import {  NavLink } from 'react-router-dom'
import { Routes } from '../../constants'
import { useAuth } from '../../contexts/AuthContext'

function Sidebar() {

    const {
        currentUser,
        isCurrentUserAdmin,
        isCurrentUserCreator,
        isCurrentUserReviewer,
    } = useAuth()

    const active = {
        color: "white !important",
        borderRight: "3px solid #bbe71f"
    };


    return (
        <aside className='h-full text-center border border-r-1 border-kyzzen-secondary bg-kyzzen-primary'>
            <ul>
                {!!currentUser && (isCurrentUserCreator() || isCurrentUserReviewer()) && (
                    <>
                        <li className="mt-8 mb-4">
                            <NavLink className="w-full font-normal text-gray-40 flex items-center justify-start pl-12 py-4 hover:text-gray-500 text-sm pb-1" to={Routes.MANAGE_COLLECTIONS} activeStyle={active}>
                                <WidgetsRounded className="mr-4" />
                                Collections
                            </NavLink>
                        </li>

                    </>
                )}

                {!!currentUser && isCurrentUserAdmin() && (<>
                    <li className="mt-8 mb-4">
                        <NavLink className="w-full font-normal text-gray-40 flex items-center justify-start pl-12 py-4 hover:text-gray-500 text-sm pb-1" to={Routes.ADMIN_NOTIFICATIONS} activeStyle={active}>
                            <WidgetsRounded className="mr-4" />
                            Notifications
                        </NavLink>
                    </li>
                    {/* <li className="my-2">
                        <NavLink className="w-full font-normal text-gray-40 flex items-center justify-start pl-12 py-4 hover:text-gray-500  text-sm" to={Routes.SOLO_VERIFICATION} activeStyle={active}>
                            <AllInclusive className="mr-4" />
                            Solo
                        </NavLink>
                    </li> */}
                    <li className="my-2">
                        <NavLink className="w-full font-normal text-gray-40 flex items-center justify-start pl-12 py-4 hover:text-gray-500  text-sm" to={Routes.FEATURED_COLLECTION} activeStyle={active}>
                            <Star className="mr-4" />
                            Featured Collections
                        </NavLink>
                    </li>
                    <li className="my-2">
                        <NavLink className="w-full font-normal text-gray-40 flex items-center justify-start pl-12 py-4 hover:text-gray-500 text-sm pb-1" to={Routes.COURSES_CATEGORY} activeStyle={active}>
                            <School className="mr-4" />
                            Kyzzen Academy
                        </NavLink>
                    </li>
                    <li className="mt-4 mb-0">
                        <NavLink className="w-full font-normal text-gray-40 flex items-center justify-start pl-12 py-4 hover:text-gray-500  text-sm" to={Routes.FEATURED_COURSES} activeStyle={active}>
                            <Star className="mr-4" />
                            Featured Courses
                        </NavLink>
                    </li>
                    {/* <li className="my-2">
                        <NavLink className="w-full font-normal text-gray-40 flex items-center justify-start pl-12 py-4 hover:text-gray-500 text-sm pb-1" to={Routes.REWARDS} activeStyle={active}>
                            <Money className="mr-4" />
                            Rewards
                        </NavLink>
                    </li> */}
                </>)}
                {!!currentUser && (isCurrentUserCreator() || isCurrentUserAdmin()) && (
                    <Fragment>
                        {/* <li className="my-2">
                            <Menu as="div" className="relative inline-block text-left">
                                <Menu.Button className="w-full font-normal text-gray-40 flex items-center justify-start py-4 hover:text-gray-500  text-sm">
                                    <RocketLaunch className="mr-4" />
                                    <div className="w-full font-normal text-gray-40">Launchpad</div>
                                    <ArrowDropDown className="ml-10 w-4" />
                                </Menu.Button>
                                <Transition
                                    as={Fragment}
                                    enter="transition ease-out duration-100"
                                    enterFrom="transform opacity-0 scale-95"
                                    enterTo="transform opacity-100 scale-100"
                                    leave="transition ease-in duration-75"
                                    leaveFrom="transform opacity-100 scale-100"
                                    leaveTo="transform opacity-0 scale-95"
                                >
                                    <Menu.Items className="flex flex-col relative  p-2">
                                        <Menu.Item>
                                            <NavLink
                                                to={Routes.CREATE_LAUNCHPAD}
                                                className="p-2 rounded-md hover:text-gray-600 w-full font-normal flex justify-between text-sm"
                                            >
                                                New Project
                                            </NavLink>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <NavLink
                                                to={Routes.MANAGE_LAUNCHPADS}
                                                className="p-2 hover:text-gray-600 w-full font-normal flex justify-between text-sm"
                                            >
                                                Manage Projects
                                            </NavLink>
                                        </Menu.Item>
                                    </Menu.Items>
                                </Transition>
                            </Menu>
                        </li> */}

                        <li className="mt-2 mb-4">
                            <NavLink className="w-full font-normal text-gray-40 flex items-center justify-start pl-12 py-4 hover:text-gray-500  text-sm pb-1" to={Routes.MINT_CALENDARS} activeStyle={active}>
                                <CalendarMonth className="mr-4" />
                                Mint Calendar
                            </NavLink>
                        </li>
                    </Fragment>
                )}
                {!!currentUser && isCurrentUserAdmin() && (<>

                    <li className="my-4">
                        <NavLink className="w-full font-normal text-gray-40 flex items-center justify-start pl-12 py-4 hover:text-gray-500 text-sm pb-1" to={Routes.DELETE_LISTING} activeStyle={active}>
                            <BookmarkRemove className="mr-4" />
                            Delete Listing
                        </NavLink>
                    </li>
                    <li className="my-4">
                        <NavLink className="w-full font-normal text-gray-40 flex items-center justify-start pl-12 py-4 hover:text-gray-500  text-sm" to={Routes.MANAGE_DELETED} activeStyle={active}>
                            <Delete className="mr-4" />
                            Deleted Collections
                        </NavLink>
                    </li>
                    <li className="my-4">
                        <NavLink className="w-full font-normal text-gray-40 flex items-center justify-start pl-12 py-4 hover:text-gray-500  text-sm" to={Routes.TELEGRAM} activeStyle={active}>
                            <Telegram className="mr-4" />
                            Telegram
                        </NavLink>
                    </li>
                    <li className='my-2'>
                        <NavLink className="w-full font-normal text-gray-40 flex items-center justify-start pl-12 py-4 hover:text-gray-500  text-sm" to={Routes.WHITELIST_PARTNER} activeStyle={active}>
                            <LinkRounded className="mr-4" />
                            Whitelist Partner
                        </NavLink>
                    </li>
                    <li className='my-2'>
                        <NavLink className="w-full font-normal text-gray-40 flex items-center justify-start pl-12 py-4 hover:text-gray-500  text-sm" to={Routes.WHITELIST_MANAGEMENT} activeStyle={active}>
                            <PlaylistAddCheck className="mr-4" />
                            Whitelist Management
                        </NavLink>
                    </li>
                    <li className='my-2'>
                        <NavLink className="w-full font-normal text-gray-40 flex items-center justify-start pl-12 py-4 hover:text-gray-500  text-sm" to={Routes.USER_MANAGEMENT} activeStyle={active}>
                            <People className="mr-4" />
                            User Management
                        </NavLink>
                    </li>
                    <li className='my-2'>
                        <NavLink className="w-full font-normal text-gray-40 flex items-center justify-start pl-12 py-4 hover:text-gray-500  text-sm" to={Routes.BOTS_CONTROL} activeStyle={active}>
                            <SmartToy className="mr-4" />
                            Bots Control
                        </NavLink>
                    </li>
                    <li className='my-2'>
                        <NavLink className="w-full font-normal text-gray-40 flex items-center justify-start pl-12 py-4 hover:text-gray-500  text-sm" to={Routes.ADD_TELEGRAM_USER} activeStyle={active}>
                            <PersonAdd className="mr-4" />
                            Add Telegram User
                        </NavLink>
                    </li>
                </>)}
            </ul>
        </aside>
    )
}

export default Sidebar
